module.exports = __webpack_public_path__ + "img/icon-wrapper.552cabac.svg";